import { useState } from "react";
import {
  Button,
  Input,
  Label,
  Modal,
  Switch,
  TextField,
} from "@heroui/react";
import { Icon } from "@iconify/react";

import { PickupDay, PickupTime } from "@/features/pickup-schedule/type.ts";
import { useUpdatePickupDay } from "@/features/pickup-schedule/use-pickup-schedule.ts";
import { TimesEditor } from "@/features/pickup-schedule/ui/times-editor.tsx";

export function EditPickupDayModal({ day }: { day: PickupDay }) {
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState(day.active);
  const [description, setDescription] = useState(day.description);
  const [times, setTimes] = useState<PickupTime[]>(day.times);

  const { mutateAsync, isPending } = useUpdatePickupDay();

  const open = () => {
    // Сбрасываем локальное состояние к актуальным данным дня.
    setActive(day.active);
    setDescription(day.description);
    setTimes(day.times);
    setIsOpen(true);
  };

  const save = () => {
    mutateAsync({
      date: day.date,
      patch: {
        active,
        description: description.trim(),
        times: times
          .map((t) => ({ value: t.value.trim(), displayTime: t.displayTime.trim() }))
          .filter((t) => t.value && t.displayTime),
      },
    }).then(() => setIsOpen(false));
  };

  return (
    <div>
      <Button isIconOnly variant="ghost" onPress={open}>
        <Icon className="size-6" icon="solar:pen-bold-duotone" />
      </Button>

      <Modal isOpen={isOpen} onOpenChange={setIsOpen}>
        <Modal.Backdrop isDismissable>
          <Modal.Container placement="center">
            <Modal.Dialog>
              <Modal.Header>
                <Modal.Heading>
                  Дата {day.date} ({day.displayDate})
                </Modal.Heading>
              </Modal.Header>

              <Modal.Body>
                <Switch isSelected={active} onChange={setActive}>
                  <Switch.Control>
                    <Switch.Thumb />
                  </Switch.Control>
                  <Switch.Content>
                    <Label>Активна</Label>
                  </Switch.Content>
                </Switch>

                <TextField value={description} onChange={setDescription}>
                  <Label>Описание</Label>
                  <Input placeholder="Например: выходной" />
                </TextField>

                <TimesEditor times={times} onChange={setTimes} />
              </Modal.Body>

              <Modal.Footer>
                <Button variant="danger-soft" onPress={() => setIsOpen(false)}>
                  Отмена
                </Button>

                <Button isPending={isPending} variant="primary" onPress={save}>
                  Сохранить
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </Modal.Container>
        </Modal.Backdrop>
      </Modal>
    </div>
  );
}
